export const homepageProductsInitialPage = 1;

export const homepageProductsItemsPerPage = 12;
